import React, { useState, useRef } from "react";
import { fetchWithDefaults } from '../../config/fetchDefault';
import Icon from "../../assets/icons/icon";


function NumberSearch({type,handleCheckboxChange,agentId}) {
    const states = [
        { abbreviation: 'AL', name: 'Alabama' },{ abbreviation: 'AK', name: 'Alaska' },{ abbreviation: 'AZ', name: 'Arizona' },{ abbreviation: 'AR', name: 'Arkansas' },{ abbreviation: 'CA', name: 'California' },{ abbreviation: 'CO', name: 'Colorado' },{ abbreviation: 'CT', name: 'Connecticut' },{ abbreviation: 'DE', name: 'Delaware' },{ abbreviation: 'FL', name: 'Florida' },{ abbreviation: 'GA', name: 'Georgia' },{ abbreviation: 'HI', name: 'Hawaii' },{ abbreviation: 'ID', name: 'Idaho' },{ abbreviation: 'IL', name: 'Illinois' },{ abbreviation: 'IN', name: 'Indiana' },{ abbreviation: 'IA', name: 'Iowa' },{ abbreviation: 'KS', name: 'Kansas' },{ abbreviation: 'KY', name: 'Kentucky' },{ abbreviation: 'LA', name: 'Louisiana' },{ abbreviation: 'ME', name: 'Maine' },{ abbreviation: 'MD', name: 'Maryland' },{ abbreviation: 'MA', name: 'Massachusetts' },{ abbreviation: 'MI', name: 'Michigan' },{ abbreviation: 'MN', name: 'Minnesota' },{ abbreviation: 'MS', name: 'Mississippi' },{ abbreviation: 'MO', name: 'Missouri' },{ abbreviation: 'MT', name: 'Montana' },{ abbreviation: 'NE', name: 'Nebraska' },{ abbreviation: 'NV', name: 'Nevada' },{ abbreviation: 'NH', name: 'New Hampshire' },{ abbreviation: 'NJ', name: 'New Jersey' },{ abbreviation: 'NM', name: 'New Mexico' },{ abbreviation: 'NY', name: 'New York' },{ abbreviation: 'NC', name: 'North Carolina' },{ abbreviation: 'ND', name: 'North Dakota' },{ abbreviation: 'OH', name: 'Ohio' },{ abbreviation: 'OK', name: 'Oklahoma' },{ abbreviation: 'OR', name: 'Oregon' },{ abbreviation: 'PA', name: 'Pennsylvania' },{ abbreviation: 'RI', name: 'Rhode Island' },{ abbreviation: 'SC', name: 'South Carolina' },{ abbreviation: 'SD', name: 'South Dakota' },{ abbreviation: 'TN', name: 'Tennessee' },{ abbreviation: 'TX', name: 'Texas' },{ abbreviation: 'UT', name: 'Utah' },{ abbreviation: 'VT', name: 'Vermont' },{ abbreviation: 'VA', name: 'Virginia' },{ abbreviation: 'WA', name: 'Washington' },{ abbreviation: 'WV', name: 'West Virginia' },{ abbreviation: 'WI', name: 'Wisconsin' },{ abbreviation: 'WY', name: 'Wyoming' }
      ];
    const innerWrapperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [searchType, setSearchType] = useState(''); 
    const [searchResult, setSearchResult] = useState([]);
    
    const handleSearchTypeChange = (event) => {
        const value = event.target.value;
        if (type === 'Area Code') {
            const digitsOnly = value.replace(/\D/g, '');
            setSearchType(digitsOnly);
        } else {
            setSearchType(value);
        }
    }; 
    const handleOptionClick = (option) => {
        //setSelectedOption(option.name || option.states);
        setIsOpen(!isOpen);
        //addToHolder(option,search);
      };
      const getHeight = () => {
          if(innerWrapperRef.current && innerWrapperRef.current.clientHeight===0){
              return 0
          }
          if (innerWrapperRef.current) {
              return innerWrapperRef.current.clientHeight;
          }
          return 0;
      };
    const searchNumber = async (type) => {
        const splitString = type.split(' ');
        type = splitString[0];
        try {
            const response = await fetchWithDefaults(`/searchNumber${type}?agent=${agentId}&search=${searchType}`);

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const jsonData = await response.json();
            setSearchResult(jsonData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    return (
        <span className="quilityNestedBlockWrapper" style={{overflow: 'hidden', height: isOpen ? 'fit-content' : '45px' }}>
            <div className="quilityNestedBlockHeader" onClick={()=>handleOptionClick()}>
                <div className="quilityParentBlockTitle">Search By {type}</div>
                <span className={`quilityBlockIcon ${isOpen ? 'rotate':''}`} style={{marginTop: '-5px', transition:'all .5s'}}><span className="fontello"><Icon name={'q-up'} size={20} className="closeIcon" adjust="fontello" /></span></span>
            </div>

            <div className="quilityNestedBlockContent" ref={innerWrapperRef}>
                <span className="searchInfoWrapper">
                    <div className="numberSearchTitle" style={{marginLeft: '0px',textIndent:'0px'}}>
                        Search By {type}
                    </div>
                    {type=='State' ? (
                        <select className="qualifierFieldInput" onChange={handleSearchTypeChange} value={searchType} style={{width: '150px',height: '30px'}}>
                            <option value="none">Select a State</option>
                        {states.map((item, index) => (
                            <option key={`states${index}`} value={item.abbreviation}>{item.name}</option>
                        ))}
                        </select>
                    ):( 
                        <input type="text" inputMode="numeric" className="qualifierFieldInput" onChange={handleSearchTypeChange} value={searchType} />
                    )}
                </span>
                <span className="searchNumbers solidQuilityActiveButton" onClick={()=>searchNumber(type)}><span className="fontello"><Icon name={'q-search'} size={20} className="" height='23' adjust="fontello" /></span></span>
                <span className="results">

                    <div className="">
                        <div className="quilityNestedBlockContent" >
                            <div className="subTitle" style={{fontWeight:'700',textAlign: 'left',textIndent: '20px'}}>
                                Search Results
                            </div>
                            <div className="innerContentWrapper">
                                {searchResult.length > 0 ?(
                                    searchResult.map((item, index) => (
                                        <div className="quilityDataLine" key={`numberSearch${index}`}>
                                            <span className="resultCheckBoxWrapper">
                                                <input type="checkbox" className="resultCheckBox" onChange={() => handleCheckboxChange(item.phoneNumber)}/>
                                            </span>
                                            <span className="quilityDataLineTitle">{item.friendlyName}</span>
                                            <span className="quilityDataLineValue">{item.locality}</span>
                                        </div>
                                    )) 
                                ):(
                                    <div className="quilityDataLine">
                                        <div className="quilityDataLineTitle" style={{textAlign: 'center'}}>No Results</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    
                </span>
            </div>
        </span>
    );
}

export default NumberSearch;

